<template>
    <section class="container">
        <div
            v-if="isLoading"
            key="loadingContent"
            class="my-8 px-4 flex justify-center"
        >
            <Spinners />
        </div>
        <div
            v-else
            key="contentLoaded"
            class="grid gap-8 md:grid-cols-3 lg:grid-cols-4"
        >
            <AttendeeCard
                v-for="attendee in attendees"
                :key="attendee.attendeeId"
                class="bg-card shadow rounded-xl h-60 flex flex-col items-center transition-shadow duration-500 ease-in-out py-8 hover:shadow-2xl"
                layout="column"
                :title="attendee.title"
                :name="attendee.firstName + ' ' + attendee.lastName"
                :nameInitial="attendee.firstName[0] + attendee.lastName[0]"
                :companyName="attendee.companyName"
                :imgPath="attendee.imgPath"
                :hasFullDetail="false"
                :id="attendee.attendeeId"
            />
        </div>
    </section>
</template>
<script>
import { mapGetters } from "vuex";
import { Component, Vue } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";

import AttendeeCard from "@/components/shared/AttendeeCard.vue";
import svgTwitter from "@/components/svg/svg-twitter.vue";
import svgLinkedin from "@/components/svg/svg-linkedin.vue";
import svgInstagram from "@/components/svg/svg-instagram.vue";
import Spinners from "@/components/utilities/Spinners.vue";

import featuredAttendeeVuexModule from "@/store/vuex-modules/getFeaturedAttendees";
const featuredAttendeeStore = getModule(featuredAttendeeVuexModule);

@Component({
    computed: {
        ...mapGetters(["awsConfig"])
    },
    components: {
        Spinners,
        AttendeeCard,
        "svg-twitter": svgTwitter,
        "svg-likedin": svgLinkedin,
        "svg-instagram": svgInstagram
    },
    created() {
        featuredAttendeeStore
            .getFeaturedAttendees({
                tableName: this.awsConfig.attendeeTable,
                isDemoData: !this.awsConfig.attendeeTable
            })
            .finally(() => {
                this.isLoading = false;
            });
    }
})
export default class AttendeeSwimLane extends Vue {
    isLoading = true;

    get attendees() {
        if (!this.awsConfig.attendeeTable) {
            return this.attendeeDummy;
        } else if (featuredAttendeeStore.featuredAttendees) {
            return featuredAttendeeStore.featuredAttendees;
        } else {
            return [];
        }
    }
}
</script>
